import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Config } from 'src/app/app-constant';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { HttpService } from 'src/app/service/http/http.service';
import { LoaderService } from 'src/app/service/loader/loader.service';
import { SharedService } from 'src/app/service/shared/shared.service';
import { ConfirmationPopupComponent } from 'src/app/shared/popups/confirmation-popup/confirmation-popup.component';
import { VariablePayLetterPopupComponent } from 'src/app/shared/popups/variable-pay-letter-popup/variable-pay-letter-popup.component';
import * as saveAs from 'file-saver';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-variable-pay-letter',
  templateUrl: './variable-pay-letter.component.html',
  styleUrls: ['./variable-pay-letter.component.scss'],
})
export class VariablePayLetterComponent  implements OnInit {

  buttonColorName: any;
  showVariablePayLetter: any;
  showBrowseBtn: boolean = false;
  fileName: any = null;
  fileType: any = null;
  formData: any = new FormData();
  loggedInUserCompanyID:any;
  isDisabledLetterHeadBtn: boolean = true;
  letterHeadUrl: any;
  selectedYear: any;
  getIncrementFyYearList:any = [];
  loggedInCompanyFiscalyear:any;
  frequencyPeriod:any;
  variablePeriodFrquency:any = [];
  setupFrequency:any;
  selectedYearForLetterHead:any;
  vpLetterPdfUrl:any;

  constructor(public router: Router, public dialog: MatDialog, private config: Config,
    private httpService: HttpService, private encryptionService: EncryptionService,
    private loader: LoaderService, public sharedService: SharedService,
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit() {
    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
    this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');
    if (this.loggedInCompanyFiscalyear) {
      this.loggedInCompanyFiscalyear = this.encryptionService.decryptData(this.loggedInCompanyFiscalyear);
    }
  }
  ionViewWillEnter() {
    this.getFiscalYearForVariableInput();
    this.showBrowseBtn = false;
    this.isDisabledLetterHeadBtn = true;
  }

  onClickGoToVariablePay(operation: any){
    this.router.navigate(['/home/hrportal/variablepay',{operation: operation}]);
  }

  editVariablePay(){
    if(this.frequencyPeriod){
      this.showVariablePayLetter = false;
      const dialogRef = this.dialog.open(VariablePayLetterPopupComponent, {
        disableClose: true,
        minHeight: '0',
        maxHeight: 'auto',
        width: 'auto',
        minWidth: '0',
        data: {
          msg: 'Email Template Updated Successfully',
          btn2: 'Done',
          btn2BgColor: this.buttonColorName,
          showSuccessIcon: false,
          showSuccessMessage: false,
          showCloseIcon: false,
          frequency: this.selectedYearForLetterHead,
          year: this.frequencyPeriod
        },
      });
      dialogRef.afterClosed().subscribe((result:any) => {
        // if (result) {
        //   this.isEditEmail = false;
        // }
      });
    }
  }

  viewVariablePayLetter(){
    this.showVariablePayLetter = !this.showVariablePayLetter;
    if(this.showVariablePayLetter){
    }
  }
  onClickDownloadLetterHeadFile() {

  }

  onFileSelected(event: Event) {
    const inputEvent: any = event.target as HTMLInputElement;
    this.fileName = null;
    this.fileType = null;
    this.formData = new FormData();
    const fileSizeInKB = inputEvent.files[0].size / 1024;
    const fileSizeInMB = fileSizeInKB / 1024;
    if (!inputEvent.files[0] || inputEvent.files[0].length == 0) {
      return;
    }

    const selectedFile = inputEvent.files[0];
    const fileName = selectedFile.name.toLowerCase();
    const fileType = selectedFile.type;
    const supportedFormats = ['pdf','PDF'];
    const fileExtension = fileName.split('.').pop();
    if (!supportedFormats.includes(fileExtension)) {
      window.alert("File format is not supported. Please upload pdf");
      return;
    }
    if (fileSizeInMB > 10) {
      window.alert("File size is greater than 10MB");
      return;
    }
    if (inputEvent.files[0]) {
      this.fileName = inputEvent.files[0].name;
      this.fileType = inputEvent.files[0].type;
      this.formData = new FormData();
      this.formData.append('file', inputEvent.files[0]);
      this.formData.append('companyId', this.loggedInUserCompanyID);
      this.showBrowseBtn = true;
      this.isDisabledLetterHeadBtn = false;
      const url = this.config.uploadFileLocally + `?fileName=${this.fileName}&fileType=${this.fileType}`;
      this.httpService.submitFormService(url, this.formData).subscribe((data: any) => {
        this.letterHeadUrl = data?.data;
      })
    }
  }
  onCloseFile() {
    this.showBrowseBtn = false;
    this.isDisabledLetterHeadBtn = true;
  }
  onSendCompanyLetterheadFile() {
    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      height: '25%',
      width: '30%',
      data: {
        msg: 'Are you sure to upload Variable Pay letter',
        btn1: 'Cancel',
        btn2: 'Yes',
        btn2BgColor: this.buttonColorName,
        showSuccessIcon: false,
        showSuccessMessage: false,
        showCloseIcon: false
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      this.saveVPPolicyFile();
    })
  }
  onYearChange(selectedYear: any) {
    this.selectedYearForLetterHead = this.selectedYear
  }
  getIncrementFyYear() {
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "fromYear": null,
      "toYear": null
    }
    this.httpService.callPostService(this.config.getOverallBudgetGrid, request).subscribe((result: any) => {
      this.getIncrementFyYearList = result.data.map((ele: any) => ({
        year: `${ele.fromYear}-${ele.toYear}`,
      }));
      const currentYear = new Date().getFullYear();
      let yearValue = this.loggedInCompanyFiscalyear === 'Jan_Dec'
        ? `${currentYear}-${currentYear}`
        : `${currentYear}-${currentYear + 1}`;

      let selectedYearIndex = this.getIncrementFyYearList.findIndex((ele: any) => ele.year === yearValue);
      if (selectedYearIndex === -1) {
        selectedYearIndex = 0;
      }
      const currentDate = new Date();
      const currentMonth = currentDate.getMonth(); 
      let yearValue1 = '';
      if (this.loggedInCompanyFiscalyear === 'Jan_Dec') {
        yearValue1 = `${currentYear}-${currentYear}`;
      } else {
        yearValue1 = `${currentYear}-${currentYear + 1}`;
        if(this.loggedInCompanyFiscalyear === 'Apr_Mar'){
          if(currentMonth<3){
            yearValue1 = `${currentYear-1}-${currentYear}`;
          }else{
            yearValue1 = `${currentYear}-${currentYear + 1}`;
          }
        }
        if(this.loggedInCompanyFiscalyear === 'July_Jun'){
          if(currentMonth<6){
            yearValue1 = `${currentYear-1}-${currentYear}`;
          }else{
            yearValue1 = `${currentYear}-${currentYear + 1}`;
          }
        }
        if(this.loggedInCompanyFiscalyear === 'Oct_Sep'){
          if(currentMonth<9){
            yearValue1 = `${currentYear-1}-${currentYear}`;
          }else{
            yearValue1 = `${currentYear}-${currentYear + 1}`;
          }
        }
      }
      this.selectedYear =  yearValue1;
      // this.selectedYear = this.getIncrementFyYearList[selectedYearIndex]?.year;
      this.selectedYearForLetterHead = yearValue1;
      this.getFrequencies();
    })
  }
  getFiscalYearForVariableInput() {
    this.httpService.callGetService(this.config.getpmsyearlist + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.getIncrementFyYearList = [];
      data?.data?.yearRanges?.forEach((ele: any) => {
        var test = ele.split('_');
        let obj = {
          year: test[0] + '-' + test[1]
        };
        this.getIncrementFyYearList.push(obj);
      });

      const currentYear = new Date().getFullYear();
      let yearValue = '';
      if (this.loggedInCompanyFiscalyear === 'Jan_Dec') {
        yearValue = `${currentYear}-${currentYear}`;
      } else {
        yearValue = `${currentYear}-${currentYear + 1}`;
      }

      let selectedYearIndex = this.getIncrementFyYearList.findIndex((ele: any) => ele.year === yearValue);
      if (selectedYearIndex === -1) {
        selectedYearIndex = 0;
      }
      const currentDate = new Date();
      const currentMonth = currentDate.getMonth(); 
      let yearValue1 = '';
      if (this.loggedInCompanyFiscalyear === 'Jan_Dec') {
        yearValue1 = `${currentYear}-${currentYear}`;
      } else {
        yearValue1 = `${currentYear}-${currentYear + 1}`;
        if(this.loggedInCompanyFiscalyear === 'Apr_Mar'){
          if(currentMonth<3){
            yearValue1 = `${currentYear-1}-${currentYear}`;
          }else{
            yearValue1 = `${currentYear}-${currentYear + 1}`;
          }
        }
        if(this.loggedInCompanyFiscalyear === 'July_Jun'){
          if(currentMonth<6){
            yearValue1 = `${currentYear-1}-${currentYear}`;
          }else{
            yearValue1 = `${currentYear}-${currentYear + 1}`;
          }
        }
        if(this.loggedInCompanyFiscalyear === 'Oct_Sep'){
          if(currentMonth<9){
            yearValue1 = `${currentYear-1}-${currentYear}`;
          }else{
            yearValue1 = `${currentYear}-${currentYear + 1}`;
          }
        }
      }
      this.selectedYear =  yearValue1;
      this.selectedYearForLetterHead = yearValue1;
      this.getFrequencies();
      this.getLetterHead();
    });
  }

  getFrequencies(){
    const test = this.selectedYearForLetterHead.split('-');
    this.httpService.callGetService(`${this.config.getPMSSetUpByID}${this.loggedInUserCompanyID}/${test[0]}/${test[1]}`).subscribe((data: any) => {
      this.setupFrequency = data.data['reviewCycle'] ? data.data['reviewCycle'] : data.data['yearRanges'];
      this.getFrequencyForInput();
    });
  }
  getFrequencyForInput() {
    const test = this.selectedYearForLetterHead.split('-');
    this.httpService.callGetService(`${this.config.variableFrequency}/${test[0]}/${test[1]}/${this.loggedInUserCompanyID}`).subscribe((response: any) => {
      this.variablePeriodFrquency = response.data;
      const currentMonthIndex = new Date().getMonth();
      const today = new Date();
      const month = today.toLocaleString('default', { month: 'long' });
      if (this.setupFrequency == 'Monthly') {
        this.variablePeriodFrquency.forEach((ele: any) => {
          var checkMonth = ele?.split('-');
          if (month == checkMonth[0]) {
            this.frequencyPeriod = ele;
          }
        });
      }
      if (this.setupFrequency == 'Quarterly' || this.setupFrequency == 'Semi_Annually'  || this.setupFrequency == 'Semi-Annually'
        || this.setupFrequency == 'Annually'
      ) {
        for (let range of this.variablePeriodFrquency) {
          const [start, end] = range?.split('-');
          const startMonthIndex = this.getMonthIndex(start);
          const endMonthIndex = this.getMonthIndex(end);
          if (
            (currentMonthIndex >= startMonthIndex && currentMonthIndex <= endMonthIndex) ||
            (startMonthIndex > endMonthIndex && (currentMonthIndex >= startMonthIndex || currentMonthIndex <= endMonthIndex))
          ) {
            this.frequencyPeriod = range;
          }
        }
      }
      // this.filterMonthsForInput(this.setupFrequency);
    });
  }
  getMonthIndex(monthName: string): number {
    const months = [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ];
    return months.findIndex(month => month.toLowerCase() === monthName.toLowerCase());
  }
  saveVPPolicyFile() {
    const test = this.selectedYear.split('-');
    if(this.letterHeadUrl != null){
      const request = {
        "companyId": this.loggedInUserCompanyID,
        "frequencyCycle": null,
        "fromYear": test[0],
        "isDeleted": false,
        "relatedToName": "VP Letter Head",
        "toYear": test[1],
        "vpPolicyFileNameBody": this.fileName,
        "vpPolicyUrlSubject": this.letterHeadUrl
      };
      this.httpService.callPostService(this.config.saveVPPolicyFile, request).subscribe((result: any) => {
        const successdialogRef = this.dialog.open(ConfirmationPopupComponent, {
          disableClose: true,
          height: '25%',
          width: '30%',
          data: {
            msg: result?.message,
            btn2: 'OK',
            btn2BgColor: this.buttonColorName,
            showSuccessIcon: true,
            showSuccessMessage: false,
            showCloseIcon: false,
          },
        });
        successdialogRef.afterClosed().subscribe(result => {
          // this.router.navigate(['/home/hrportal/variablepay', { operation: 'Setup' }]);
        });
      });
    }
  }
  getVPPolicyFile() {
    const test = this.selectedYearForLetterHead.split('-');
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "frequencyCycle": null,
      "fromYear": test[0],
      "relatedToName": "VP Letter Head",
      "toYear": test[1]
    };
    this.httpService.callPostService(this.config.getVPPolicyFile, request).subscribe((result: any) => {
           const downloadFile: any = result.data;
            if (downloadFile.vpPolicyUrlSubject) {
              var fileName = downloadFile.vpPolicyUrlSubject.split(environment.downloadURL)
              saveAs(downloadFile.vpPolicyUrlSubject, fileName[1]);
            }

      // var fileName = result?.fileUrl?.split(environment.downloadURL)
      // saveAs(result?.data?.vpPolicyUrlSubject, fileName[1]); 
      
      // saveAs(environment.downloadURL+result?.data?.vpPolicyUrlSubject, result?.data?.vpPolicyFileNameBody);
    });
  }

  getLetterHead(){
    const test = this.selectedYearForLetterHead.split('-');
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "frequencyCycle": null,
      "fromYear": test[0],
      "relatedToName": "VP Letter Head",
      "toYear": test[1]
    };
    this.httpService.callPostService(this.config.getVPPolicyFile, request).subscribe((result: any) => {
      if(result.data?.vpPolicyFileNameBody !== null && result.data !== null){
        this.fileName = result.data?.vpPolicyFileNameBody;
        this.showBrowseBtn = true;
      }else{
        this.fileName = null
        this.showBrowseBtn = false;
      }
    });
  }

  VPgetLetterOfUsers(){
    this.showVariablePayLetter = !this.showVariablePayLetter
    const test = this.selectedYearForLetterHead.split('-');
    if(this.showVariablePayLetter == true){
      const request = {
        "companyId": this.loggedInUserCompanyID,
        "frequencyCycle": this.frequencyPeriod,
        "fromYear": test[0],
        "toYear": test[1],
        "userId": []
      };
      this.loader.simpleLoader();
      this.httpService.callPostService(this.config.viewVariablePayLetter, request).subscribe((result: any) => {
        if(result?.data!=null){
          // const googleDocsUrl = `https://docs.google.com/gview?embedded=true&url=${result?.data}`;
          // this.vpLetterPdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(googleDocsUrl);
  
          this.vpLetterPdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
            `https://docs.google.com/gview?url=${encodeURIComponent(result?.data)}&embedded=true`
          );
        }
        this.loader.dismissLoader();
      });
    }
  }
}
